module.exports = __webpack_public_path__ + "img/3OOx25O.e402a4fc.svg";